import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery, select } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { alert } from "../../../../Utils/toast";
import { setDiscountCode } from "../../discountCode/discountCode";
// import { CheckDiscountDataTypes } from "../../../../Schema/checkDiscount.types";

export type CheckDiscountLoadAction = {
  type: string;
  payload: { service_id: number; sub_services: number; discount_code: string };
};

export type CheckDiscountData = {
  data: { payable_amount: number; total_amount: number };
};

const CheckDiscount = new ReduxFetchState<
  CheckDiscountData,
  { service_id: number; sub_services: number; discount_code: string },
  any
>("checkDiscount");

export function* watchCheckDiscount(action: CheckDiscountLoadAction) {
  try {
    const { sub_services, service_id, discount_code } = action.payload;

    const lang: "fa" | "en" = yield getCurrentLanguage();

    const data: CheckDiscountData = yield axios({
      headers: {
        lang,
      },
      url: "/api/v1/ai/check-discount",
      method: "POST",
      data: {
        sub_services,
        service_id,
        discount_code,
      },
    });

    yield put(CheckDiscount.actions.loadSuccess({ data: data.data }));
    yield put(setDiscountCode({ code: discount_code, type: "subService" }));
  } catch (e: any) {
    alert({
      message: e?.response?.data?.error ?? "مشکلی پیش آمده",
      type: "error",
    });
    yield put(CheckDiscount.actions.loadFailure(e.message));
  }
}

export function* checkDiscountSagas() {
  yield takeEvery(CheckDiscount.actionTypes.load, watchCheckDiscount);
}

export function useCheckDiscount() {
  const { loading, data, ...checkDiscountState } = useAppSelector(
    (state) => state.checkDiscount,
  );
  const dispatch = useAppDispatch();

  const dispatchCheckDiscount = useCallback(
    (data: {
      service_id: number;
      sub_services: number;
      discount_code: string;
    }) => {
      dispatch(CheckDiscount.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...checkDiscountState,
    dispatchCheckDiscount,
    checkDiscountLoading: loading,
    checkDiscountData: data,
  };
}

export const {
  actionTypes: checkDiscountActionsTypes,
  actions: checkDiscountActions,
  reducer: checkDiscountReducer,
} = CheckDiscount;
